import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';

import aviator1 from '../../assets/images/home/hompage/Desktopaviator.png';
import aviator2 from '../../assets/images/home/hompage/Desktopbollywood.png';
import aviator3 from '../../assets/images/home/hompage/Desktopcolor.png';
import aviator4 from '../../assets/images/home/hompage/Desktoplankesh.png';
import aviator5 from '../../assets/images/home/hompage/Desktopmines.png';
import aviator6 from '../../assets/images/home/hompage/Desktopvalentine.png';
import aviator7 from '../../assets/images/home/hompage/DesktopPlinko.png';


import mobimage1 from '../../assets/images/home/hompage/Aviator.png';
import mobimage5 from '../../assets/images/home/hompage/Bollywood Kiss.png';
import mobimage3 from '../../assets/images/home/hompage/Color Prediction.png';
import mobimage4 from '../../assets/images/home/hompage/Lankesh.png';
import mobimage2 from '../../assets/images/home/hompage/Mines.png';
import mobimage7 from '../../assets/images/home/hompage/Plinko.png';
import mobimage6 from '../../assets/images/home/hompage/Valentine.png';



import './Categorygames.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../models/RootState';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { SportIconMap, SportIdByNameMap } from '../../util/stringUtil';
import { isMobile } from 'react-device-detect';

interface GamesContainerProps {
  title: string;
  gameList: any[];
}
const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: isMobile ? 2 : 6,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: isMobile ? 2000 : 500,
  pauseOnHover: true,
};

const Categorygames: React.FC<GamesContainerProps> = ({ title, gameList }) => {
  const loggedIn = useSelector((state: RootState) => state.auth.loggedIn);
  const langData = useSelector((state: RootState) => state.common.langData);
  const [dialogShow, setDialogShow] = useState<boolean>(false);
  // const [selectedCategory, setSelectedCategory] = useState(tabs);
  const [gamesDisplay, setGamesDisplay] = useState([]);
  const [activeCategory, setActiveCategory] = useState<string | null>(
    'Originals'
  );

  const history = useHistory();

  // const navigate = useNavigate();
  const gamesContainerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="games-container">
      <div className="games-container-card">
        <div className="games-header">
          <div className="categories-container">
            <div className="category-item">{title}</div>
            <div className="gradient-line"></div>
          </div>
        </div>
               <Slider className='custom-slider web-view' {...settings}>
        
<div className='provider-ctn'  onClick={() => {
                history.push("/dc/gamev1.1/aviator-ODYwMDAx-c3ByaWJlX2F2aWF0b3I=-U1BSSUJF-U1BSSUJF")
              }}> <img className="provider-img" loading="lazy" src={aviator1} /></div>
<div  className='provider-ctn'  onClick={() => {
                                     history.push("/dc/gamev1.1/bolly-kiss-MTUxMDc5-TUFDODgtQksxMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")

              }}><img className="provider-img" loading="lazy" src={aviator2} /></div>
<div   className='provider-ctn'  onClick={() => {
                    history.push("/dc/gamev1.1/color-prediction-NjAwMTQ0-amlsaV9jb2xvcl9wcmVkaWN0aW9u-SmlMaQ==-SmlMaSBHYW1pbmc=")
                  }}><img className="provider-img" loading="lazy" src={aviator3} /></div>
<div  className='provider-ctn'  onClick={() => {
                        history.push("/dc/gamev1.1/lankesh-MTUxMDI2-TUFDODgtVlRHTE4xMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")
                      }}><img className="provider-img" loading="lazy" src={aviator4} /></div>
<div   className='provider-ctn' onClick={() => {
                      history.push("/dc/gamev1.1/mines-MjAxMjA4-c2JlX21pbmVz-REM=-U3ByaWJl")
                    }}><img className="provider-img" loading="lazy" src={aviator5} /></div>
<div    className='provider-ctn'   onClick={() => {
                      history.push("/dc/gamev1.1/5-boys-MTUxMDg4-TUFDODgtRkIxMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")
                    }}><img className="provider-img" loading="lazy" src={aviator6} /></div>

                     <div   className='provider-ctn'    onClick={() => {
                      history.push("/dc/gamev1.1/plinko-MjAxMjA5-c2JlX3BsaW5rbw==-REM=-U3ByaWJl")
                    }}><img className="provider-img" loading="lazy" src={aviator7} /></div>
                    </Slider>

                    <Slider className='mob-view'  {...settings}>
<div  className='provider-ctn' onClick={() => {
                history.push("/dc/gamev1.1/aviator-ODYwMDAx-c3ByaWJlX2F2aWF0b3I=-U1BSSUJF-U1BSSUJF")
              }}> <img className="provider-img" loading="lazy" src={mobimage1} /></div>
<div className='provider-ctn'  onClick={() => {
                history.push("/dc/gamev1.1/mines-MjAxMjA4-c2JlX21pbmVz-REM=-U3ByaWJl")
              }}><img className="provider-img" loading="lazy" src={mobimage2} /></div>
<div  className='provider-ctn'  onClick={() => {
                    history.push("/dc/gamev1.1/color-prediction-NjAwMTQ0-amlsaV9jb2xvcl9wcmVkaWN0aW9u-SmlMaQ==-SmlMaSBHYW1pbmc=")
                  }}><img className="provider-img" loading="lazy" src={mobimage3} /></div>
<div className='provider-ctn'  onClick={() => {
                        history.push("/dc/gamev1.1/lankesh-MTUxMDI2-TUFDODgtVlRHTE4xMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")
                      }}><img className="provider-img" loading="lazy" src={mobimage4} /></div>
<div className='provider-ctn'  onClick={() => {
                      history.push("/dc/gamev1.1/bolly-kiss-MTUxMDc5-TUFDODgtQksxMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")
                    }}><img className="provider-img" loading="lazy" src={mobimage5} /></div>
<div   className='provider-ctn'   onClick={() => {
                      history.push("/dc/gamev1.1/5-boys-MTUxMDg4-TUFDODgtRkIxMDE=-TUFDODg=-TWFjODggR2FtaW5nIFZpcnR1YWw=")
                    }}><img className="provider-img" loading="lazy" src={mobimage6} /></div>

                     <div  className='provider-ctn'    onClick={() => {
                      history.push("/dc/gamev1.1/plinko-MjAxMjA5-c2JlX3BsaW5rbw==-REM=-U3ByaWJl")
                    }}><img className="provider-img" loading="lazy" src={mobimage7} /></div>
   </Slider>
       
      </div>
    </div>
  );
};

export default Categorygames;
